import { render } from "./ButtonsBlock.vue?vue&type=template&id=a86ca164&scoped=true"
import script from "./ButtonsBlock.vue?vue&type=script&lang=js"
export * from "./ButtonsBlock.vue?vue&type=script&lang=js"

import "./ButtonsBlock.vue?vue&type=style&index=0&id=a86ca164&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86ca164"]])

export default __exports__